module.exports = __webpack_public_path__ + "static/media/user-03-web.7d8878f0.png";